// extracted by css-extract-rspack-plugin
export default {"serarchFrom":"serarchFrom___Pny4I","input_contain":"input_contain___irGSk","footer":"footer___ZZr1C"};